import React from "react";
import AuditFormSunQuestion from "./AuditFormSunQuestion";
import AuditFormAnswerField from "../AuditFormAnswerField/AuditFormAnswerField";

function AuditFormSubQuestionUi({
  formik,
  handleSubQuestionChange,
  removeSubQuetionField,
  addNewSubQuetionField,
  addSubQuestonOptionField,
  removeSubQuestionOptionsField,
  handleSubQuetionsOptionsChange,
  subQuestionErrors,
}) {
  return (
    <div>
      <div className="p-2">
        {formik?.values?.sub_question?.map((val, index) => {
          return (
            <div
              key={index}
              className="mt-3 p-3"
              style={{ backgroundColor: "#dfdfdf", borderRadius: "10px" }}
            >
              <div className="d-flex  mb-2">
                <div className="form-group" style={{ width: "100%" }}>
                  <label htmlFor="question">Question</label>
                  <input
                    type="text"
                    name={`sub_question[${index}].question`}
                    value={val?.question}
                    //   disabled={disabled}
                    placeholder="Enter Question"
                    className={`form-control mr-2 ${
                      subQuestionErrors &&
                      (subQuestionErrors[index]?.question
                        ? "is-invalid border-danger"
                        : "")
                    }`}
                    onChange={(e) =>
                      handleSubQuestionChange(index, e.target.value, "question")
                    }
                  />
                  {subQuestionErrors && subQuestionErrors[index]?.question && (
                    <span className="invalid-feedback">
                      {subQuestionErrors[index]?.question}
                    </span>
                  )}
                </div>
                {/* {!id && ( */}
                <div className="d-flex align-items-center" style={{height:"50px",marginTop:"18px"}}>
                  {formik?.values?.sub_question?.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-danger ml-2 mt-3"
                      onClick={() => removeSubQuetionField(index)}
                    >
                      -
                    </button>
                  )}
                  {index === formik.values.sub_question.length - 1 && (
                    <button
                      type="button"
                      className="btn btn-success ml-2 mt-3"
                      onClick={addNewSubQuetionField}
                    >
                      +{" "}
                    </button>
                  )}
                </div>
                {/* )} */}
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="input_type">Input Type</label>
                  <div>
                    <select
                      name={`sub_question[${index}].input_type`}
                      value={val?.input_type}
                      //   disabled={disabled}
                      className={`w-100 p-2 select_css ${
                        subQuestionErrors &&
                        subQuestionErrors[index]?.input_type
                          ? "is-invalid border-danger"
                          : ""
                      }`}
                      onChange={(e) =>
                        handleSubQuestionChange(
                          index,
                          e.target.value,
                          "input_type"
                        )
                      }
                    >
                      <option value="">Select Input Type</option>
                      <option value="text">Text</option>
                      <option value="dropdown">Dropdown</option>
                      <option value="checkbox">Checkbox</option>
                      <option value="radio">Radio</option>
                      <option value="date">Date</option>
                    </select>
                    {subQuestionErrors &&
                      subQuestionErrors[index]?.input_type && (
                        <span className="invalid-feedback">
                          {subQuestionErrors[index]?.input_type}
                        </span>
                      )}
                  </div>
                </div>
                <div className="form-grid">
                  <div className="form-group mt-4">
                    {/* <label htmlFor="mandatory">Mandatory</label> */}
                    <div className="form-check">
                      <input
                        id="mandatory"
                        name={`sub_question[${index}].mandatory`}
                        checked={val?.mandatory}
                        onChange={(e) =>
                          handleSubQuestionChange(
                            index,
                            e.target.checked,
                            "mandatory"
                          )
                        }
                        className="form-check-input form-control"
                        type="checkbox"
                        // disabled={disabled}
                      />
                      <label className="form-check-label">Mandatory</label>
                    </div>
                    {formik.errors.mandatory && formik.touched.mandatory && (
                      <span className="invalid-feedback">
                        {formik.errors.mandatory}
                      </span>
                    )}
                  </div>

                  {formik?.values?.sub_question[index].input_type == "text" ? (
                    <div className="form-group mt-4">
                      {/* <label htmlFor="multiline">Multiline</label> */}
                      <div className="form-check">
                        <input
                          id="multiline"
                          className="form-check-input form-control"
                          type="checkbox"
                          checked={val?.multiline}
                          name={`sub_question[${index}].multiline`}
                          onChange={(e) =>
                            handleSubQuestionChange(
                              index,
                              e.target.checked,
                              "multiline"
                            )
                          }
                        />
                        <label className="form-check-label">Multiline</label>
                      </div>
                      {/* {formik.errors.multiline && formik.touched.multiline && (
                        <span className="invalid-feedback">
                          {formik.errors.multiline}
                        </span>
                      )} */}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="form-grid">
                {formik?.values?.sub_question[index]?.input_type !==
                  "radio" && (
                  <div>
                    {formik?.values?.sub_question[index]?.input_type ==
                    "dropdown" ? (
                      <div className="form-group">
                        <label htmlFor="dropdown_type">Dropdown Type</label>
                        <div>
                          <select
                            id="dropdown_type"
                            value={val?.dropdown_type}
                            name={`sub_question[${index}].dropdown_type`}
                            // disabled={disabled}
                            className={`w-100 p-2 select_css ${
                              subQuestionErrors &&
                              subQuestionErrors[index]?.dropdown_type
                                ? "is-invalid border-danger"
                                : ""
                            }`}
                            onChange={(e) =>
                              handleSubQuestionChange(
                                index,
                                e.target.value,
                                "dropdown_type"
                              )
                            }
                          >
                            <option value="">Select Dropdown Type</option>
                            <option value="numeric">Numeric</option>
                            <option value="custom">Custom</option>
                            <option value="autogenerate">Auto Generate</option>
                          </select>
                          {subQuestionErrors &&
                            subQuestionErrors[index]?.dropdown_type && (
                              <span className="invalid-feedback">
                                {subQuestionErrors[index]?.dropdown_type}
                              </span>
                            )}
                        </div>
                      </div>
                    ) : null}
                    {formik?.values?.sub_question[index].input_type ==
                    "checkbox" ? (
                      <div className="form-group">
                        <label htmlFor="checkbox_type">Checkbox Type</label>
                        <div>
                          <select
                            id="checkbox_type"
                            value={val?.checkbox_type}
                            name={`sub_question[${index}].checkbox_type`}
                            // disabled={disabled}
                            className={`w-100 p-2 select_css ${
                              subQuestionErrors &&
                              subQuestionErrors[index]?.checkbox_type
                                ? "is-invalid border-danger"
                                : ""
                            }`}
                            onChange={(e) =>
                              handleSubQuestionChange(
                                index,
                                e.target.value,
                                "checkbox_type"
                              )
                            }
                          >
                            <option value="">Select Checkbox Type</option>
                            <option value="single">Single</option>
                            {/* <option value="multiple">multiple</option> */}
                          </select>
                          {subQuestionErrors &&
                            subQuestionErrors[index]?.checkbox_type && (
                              <span className="invalid-feedback">
                                {subQuestionErrors[index]?.checkbox_type}
                              </span>
                            )}
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
                {formik?.values?.sub_question[index]?.input_type == "radio" ||
                formik?.values?.sub_question[index]?.dropdown_type ==
                  "custom" ||
                formik?.values?.sub_question[index]?.checkbox_type ==
                  "single" ? (
                  <div className="form-group">
                    <label htmlFor="options">Options</label>
                    <div>
                      {formik?.values?.sub_question[index]?.options?.map(
                        (cen, ind) => (
                          <div key={ind}>
                            <div className="d-flex align-items-center mb-2">
                              <input
                                type="text"
                                name={`options[${ind}]`}
                                value={cen}
                                //   disabled={disabled}
                                placeholder="Enter Options"
                                className="form-control mr-2"
                                onChange={(e) =>
                                  handleSubQuetionsOptionsChange(
                                    index,
                                    ind,
                                    e.target.value
                                  )
                                }
                                onInput={(e) => {
                                  const value = e.target.value;
                                  e.target.value = value.slice(0, 25); // Limit to 10 digits
                                }}
                              />
                              {/* {!id && ( */}
                              <>
                                {formik?.values?.sub_question[index]?.options
                                  ?.length > 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() =>
                                      removeSubQuestionOptionsField(index, ind)
                                    }
                                  >
                                    -
                                  </button>
                                )}
                                {ind === formik?.values?.sub_question[index]?.options.length - 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-success ml-2"
                                    onClick={() =>
                                      addSubQuestonOptionField(index)
                                    }
                                  >
                                    +{" "}
                                  </button>
                                )}
                              </>
                              {/* )} */}
                            </div>
                            {/* {formik.errors.cens && formik.touched.cens && ((isArray(formik.errors?.cens) && index in formik.errors?.cens) || (!isArray(formik.errors?.cens) && formik.errors?.cens))&& (
                                <div className="select-error">{isArray(formik.errors?.cens) ? formik.errors?.cens[index] : formik.errors?.cens}</div>
                            )} */}
                          </div>
                        )
                      )}
                      {subQuestionErrors &&
                        subQuestionErrors[index]?.options && (
                          <div className="select-error">
                            {subQuestionErrors[index]?.options}
                          </div>
                        )}
                    </div>
                  </div>
                ) : null}
                {formik?.values?.sub_question[index].dropdown_type ==
                  "numeric" &&
                formik?.values?.sub_question[index].input_type == "dropdown" ? (
                  <div className="form-grid">
                    <div className="form-group">
                      <label htmlFor="min">Min</label>
                      <input
                        type="number"
                        value={val?.min}
                        name={`sub_question[${index}].min`}
                        // disabled={disabled}
                        className={`form-control ${
                          subQuestionErrors && subQuestionErrors[index]?.min
                            ? "is-invalid"
                            : ""
                        }`}
                        id="min"
                        min={0}
                        placeholder="Enter Min"
                        onChange={(e) =>
                          handleSubQuestionChange(index, e.target.value, "min")
                        }
                      />
                      {subQuestionErrors && subQuestionErrors[index]?.min && (
                        <span className="invalid-feedback">
                          {subQuestionErrors[index]?.min}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="max">Max</label>
                      <input
                        type="number"
                        value={val?.max}
                        name={`sub_question[${index}].max`}
                        onChange={(e) =>
                          handleSubQuestionChange(index, e.target.value, "max")
                        }
                        // disabled={disabled}
                        className={`form-control ${
                          subQuestionErrors && subQuestionErrors[index]?.max
                            ? "is-invalid"
                            : ""
                        }`}
                        id="max"
                        min={0}
                        placeholder="Enter Max"
                      />
                      {subQuestionErrors && subQuestionErrors[index]?.max && (
                        <span className="invalid-feedback">
                          {subQuestionErrors[index]?.max}
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}
                {formik?.values?.sub_question[index].dropdown_type ==
                  "autogenerate" &&
                formik?.values?.sub_question[index].input_type == "dropdown" ? (
                  <div className="form-grid">
                    <div className="form-group">
                      <label htmlFor="title">Title</label>
                      <input
                        type="text"
                        value={val?.title}
                        name={`sub_question[${index}].title`}
                        // disabled={disabled}
                        className={`form-control ${
                          subQuestionErrors && subQuestionErrors[index]?.title
                            ? "is-invalid"
                            : ""
                        }`}
                        id="title"
                        placeholder="Enter title"
                        onChange={(e) =>
                          handleSubQuestionChange(
                            index,
                            e.target.value,
                            "title"
                          )
                        }
                      />
                      {subQuestionErrors && subQuestionErrors[index]?.title && (
                        <span className="invalid-feedback">
                          {subQuestionErrors[index]?.title}
                        </span>
                      )}
                    </div>
                    <div className="form-grid">
                      <div className="form-group">
                        <label htmlFor="min">Min</label>
                        <input
                          type="number"
                          value={val?.min}
                          name={`sub_question[${index}].min`}
                          //   disabled={disabled}
                          className={`form-control ${
                            subQuestionErrors && subQuestionErrors[index]?.min
                              ? "is-invalid"
                              : ""
                          }`}
                          id="min"
                          min={0}
                          placeholder="Enter Min"
                          onChange={(e) =>
                            handleSubQuestionChange(
                              index,
                              e.target.value,
                              "min"
                            )
                          }
                        />
                        {subQuestionErrors && subQuestionErrors[index]?.min && (
                          <span className="invalid-feedback">
                            {subQuestionErrors[index]?.min}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="max">Max</label>
                        <input
                          type="number"
                          name={`sub_question[${index}].max`}
                          //   disabled={disabled}
                          value={val?.max}
                          className={`form-control ${
                            subQuestionErrors && subQuestionErrors[index]?.max
                              ? "is-invalid"
                              : ""
                          }`}
                          id="max"
                          min={0}
                          placeholder="Enter Max"
                          onChange={(e) =>
                            handleSubQuestionChange(
                              index,
                              e.target.value,
                              "max"
                            )
                          }
                        />
                        {subQuestionErrors && subQuestionErrors[index]?.max && (
                          <span className="invalid-feedback">
                            {subQuestionErrors[index]?.max}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              {/* {formik?.values?.sub_question?.input_type !== "" &&
              formik?.values?.sub_question?.checkbox_type !== "multiple" ? (
                <>
                  <div className="form-group">
                    <label htmlFor="answer">Answer</label>
                    <AuditFormAnswerField
                      values={formik?.values?.sub_question[index]}
                      formik={formik}
                      index={index}
                      subQuestion={true}
                      handleSubQuestionChange={handleSubQuestionChange}
                    />
                  </div>
                </>
              ) : null} */}
              {/* {formik?.values.sub_question[index].checkbox_type == "multiple" ?
          <>
            <label htmlFor="question">Sub Questions</label>
            <AuditFormSunQuestion formik={formik} handleSubQuestionChange={handleSubQuestionChange} removeSubQuetionField={removeSubQuetionField} addNewSubQuetionField={addNewSubQuetionField}/>
          
          </>
          : null} */}
            </div>
          );
        })}

        {/* <div className="select-error">{isOpetionError}</div> */}
      </div>
    </div>
  );
}

export default AuditFormSubQuestionUi;
